module.exports = __webpack_public_path__ + "static/media/profile-image.776b2a97.png";